export default "__VITE_ASSET__6498a27c__"